// extracted by mini-css-extract-plugin
export default {"primary":"#027ffe","secondary":"#1b2050","highlight":"#ff31a8","background":"#f2f3f5","white":"#fff"};